<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="where" label-width="77px" class="ele-form-search" @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="租户名称">
              <el-select clearable v-model="where.tenant_id" placeholder="请选择" class="ele-block">
                <el-option v-for="item in tenantList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="租户账号">
              <el-input clearable v-model.trim="where.username" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="手机号码">
              <el-input clearable v-model.trim="where.mobile" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="电子邮箱">
              <el-input clearable v-model.trim="where.email" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">
                查询
              </el-button>
              <el-button @click="reset">
                重置
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns" :selection.sync="selection"
        height="calc(100vh - 315px)">
        <!-- 表头工具栏 -->
        <template slot="toolbar">
          <el-button @click="openEdit(null)" type="primary" icon="el-icon-plus" class="ele-btn-icon" size="small">添加
          </el-button>
          <el-button :disabled="!selection.length" @click="removeBatch" type="danger" icon="el-icon-delete"
            class="ele-btn-icon" size="small">删除
          </el-button>
        </template>
        <!-- 运营商列 -->
        <template slot="tenant_name" slot-scope="{ row }">
          <span>{{ row.tenant_name }}</span>
        </template>
        <!-- 角色列 -->
        <template slot="roles" slot-scope="{ row }">
          <el-tag v-for="item in row.roles" :key="item.id" size="mini" type="primary" :disable-transitions="true">
            {{ item.name }}
          </el-tag>
        </template>
        <!-- 状态列 -->
        <template slot="status" slot-scope="{ row }">
          <el-switch v-model="row.status" @change="editStatus(row)" :active-value="1" :inactive-value="2" />
        </template>
        <!-- 操作列 -->
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" :underline="false" @click="openEdit(row)">
            编辑
          </el-button>
          <el-popconfirm class="ele-action" title="确定要删除此租户吗？" @confirm="remove(row)">
            <el-button size="small" type="danger" class="ele-btn-icon" :underline="false" slot="reference">
              删除
            </el-button>
          </el-popconfirm>
          <el-popconfirm class="ele-action" title="确定要重置密码吗？" @confirm="resetPwd(row)">
            <el-button size="small" type="success" class="ele-btn-icon" :underline="false" slot="reference">
              重置
            </el-button>
          </el-popconfirm>
          <el-button size="small" type="warning" class="ele-btn-icon" :underline="false" @click="openStaffList(row)">
            子账号
          </el-button>
        </template>
      </ele-pro-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <user-edit :data="current" :visible.sync="showEdit" @done="reload" />
    <!-- 子账号列表 -->
    <staff-list-dialog :tenant-admin="staffAdmin" :visible.sync="showStaffList" />
  </div>
</template>

<script>
import UserEdit from "./user-edit";
import StaffListDialog from "./staff-list-dialog";

export default {
  name: "SystemTenantAdmin",
  components: { UserEdit, StaffListDialog },
  data() {
    return {
      // 表格数据接口
      url: "/tenantadmin/index",
      // 表格列配置
      columns: [
        {
          columnKey: "selection",
          type: "selection",
          width: 45,
          align: "center",
          fixed: "left",
        },
        {
          prop: "id",
          label: "序号",
          width: 60,
          align: "center",
          showOverflowTooltip: true,
          fixed: "left",
        },
        {
          columnKey: "tenant_name",
          prop: "tenant_name",
          label: "运营商名称",
          align: "center",
          showOverflowTooltip: true,
          minWidth: 120,
          slot: "tenant_name",
        },
        {
          prop: "username",
          label: "账号",
          align: "center",
          showOverflowTooltip: true,
          minWidth: 100,
        },
        {
          prop: "mobile",
          label: "手机",
          align: "center",
          showOverflowTooltip: true,
          minWidth: 100,
        },
        {
          prop: "email",
          label: "邮箱",
          align: "center",
          showOverflowTooltip: true,
          minWidth: 110,
        },
        {
          prop: "login_ip",
          label: "IP地址",
          align: "center",
          showOverflowTooltip: true,
          minWidth: 110,
        },
        {
          columnKey: "roles",
          label: "角色",
          align: "center",
          showOverflowTooltip: true,
          minWidth: 100,
          slot: "roles",
        },

        {
          prop: "status",
          label: "状态",
          align: "center",
          width: 100,
          resizable: false,
          slot: "status",
        },
        {
          prop: "create_time",
          label: "创建时间",
          align: "center",
          showOverflowTooltip: true,
          minWidth: 100,
          formatter: (row, column, cellValue) => {
            return this.$util.toDateString(cellValue);
          },
        },
        {
          prop: "update_time",
          label: "更新时间",
          align: "center",
          showOverflowTooltip: true,
          minWidth: 100,
          formatter: (row, column, cellValue) => {
            return this.$util.toDateString(cellValue);
          },
        },
        {
          columnKey: "action",
          label: "操作",
          width: 380,
          align: "center",
          resizable: false,
          slot: "action",
          fixed: "right",
        },
      ],
      // 表格搜索条件
      where: {},
      // 表格选中数据
      selection: [],
      // 当前编辑数据
      current: null,
      // 是否显示编辑弹窗
      showEdit: false,
      showImport: false,
      showStaffList: false,
      staffAdmin: null,
      tenantList: [],
    };
  },
  mounted() {
    this.queryTenants();
  },
  methods: {
    queryTenants() {
      this.$http.get('/tenant/options').then(res => {
        if (res.data.code === 0) {
          this.tenantList = res.data.data || [];
        }
      }).catch(() => { });
    },
    /* 刷新表格 */
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    /* 重置搜索 */
    reset() {
      this.where = {};
      this.reload();
    },
    /* 显示编辑 */
    openEdit(row) {
      this.current = row;
      this.showEdit = true;
    },
    openStaffList(row) {
      this.staffAdmin = row;
      this.showStaffList = true;
    },
    /* 删除 */
    remove(row) {
      const loading = this.$loading({ lock: true });
      this.$http
        .post("/tenantadmin/delete", { id: row.id })
        .then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
    },
    /* 批量删除 */
    removeBatch() {
      if (!this.selection.length) {
        this.$message.error("请选择");
        return;
      }
      this.$confirm("确定要删除选中的用户吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          const loading = this.$loading({ lock: true });
          this.$http
            .post("/tenantadmin/delete", { id: this.selection.map((d) => d.id) })
            .then((res) => {
              loading.close();
              if (res.data.code === 0) {
                this.$message({ type: "success", message: res.data.msg });
                this.reload();
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        })
        .catch(() => { });
    },
    /* 更改状态 */
    editStatus(row) {
      const loading = this.$loading({ lock: true });
      let params = Object.assign({
        id: row.id,
        status: row.status,
      });
      this.$http
        .post("/tenantadmin/status", params)
        .then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({ type: "success", message: res.data.msg });
          } else {
            row.status = !row.status ? 1 : 2;
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
    },
    /**
     * 重置密码
     */
    resetPwd(row) {
      const loading = this.$loading({ lock: true });
      this.$http
        .post("/tenantadmin/resetPwd", { id: row.id })
        .then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message({ type: "success", message: res.data.msg });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
    },
  },
};
</script>

<style scoped></style>
